export const privacyContent = `
<div class="space-y-8">
  <!-- 1. 我們是誰 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">我們是誰</h2>
    <p class="text-gray-300 leading-relaxed">
      我們是 <strong>OXO Play</strong>（以下稱「<em>OXO Play</em>」、「<em>我們</em>」）。我們提供一個線上遊戲平台（以下稱「<em>平台</em>」），讓使用者能夠方便地發掘並體驗多種網頁遊戲。您可以選擇註冊帳號（以下稱「<em>帳號</em>」）或直接使用平台。平台可透過我們的官方網站（以下稱「<em>網站</em>」，可能因地區而有所不同）存取。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      我們非常重視並尊重您賦予的信任，並嚴肅看待保護您的隱私。本隱私權政策（以下稱「<em>本政策</em>」）說明了當您使用我們的平台時，我們如何收集、處理、揭露、保存以及保護您的個人資料。請仔細閱讀以瞭解您的權利以及我們的義務。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      我們的平台原則上僅提供給年滿 13 歲（或您所在地法律要求的最低年齡）以上的使用者。如果您未滿 13 歲（或所在地的最低年齡），請勿使用本平台。我們不會刻意向低於法定年齡的使用者蒐集或索取個人資料。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      關於我們的服務使用條款（Terms of Service），請另外參考相關文件。
    </p>
  </section>

  <!-- 2. 什麼是個人資料 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">什麼是個人資料</h2>
    <p class="text-gray-300 leading-relaxed">
      「<strong>個人資料</strong>」指的是任何能直接或間接識別您身分的資訊，例如您的姓名或電子郵件地址。如果能與您的帳號進行連結，像是您曾經玩過的遊戲紀錄等，也可能被視為個人資料。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      尤其在多人連線遊戲等情況下，我們建議您避免使用真實姓名或分享個人資料。
    </p>
  </section>

  <!-- 3. 我們從哪些對象收集個人資料 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">我們從哪些對象收集個人資料</h2>
    <p class="text-gray-300 leading-relaxed">
      為了維運平台，我們可能會透過以下來源收集資料：
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li>平台與網站的訪客及使用者</li>
      <li>網頁遊戲的開發者</li>
      <li>主動提供聯絡資料（如電子郵件）的個人</li>
      <li>以電子郵件或其他管道與我們聯繫的任何人</li>
    </ul>
    <p class="text-gray-300 leading-relaxed mt-4">
      如上所述，我們原則上只向年滿 13 歲（或符合當地最低法定年齡）的使用者收集資料。
    </p>
  </section>

  <!-- 4. OXO Play 處理哪些個人資料以及目的 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">OXO Play 處理哪些個人資料以及目的</h2>
    <p class="text-gray-300 leading-relaxed">
      下表列出我們可能收集與處理的個人資料類型、使用目的（「為什麼」）以及相應的法律依據（「依據」）：
    </p>
    <div class="overflow-auto mt-4">
      <table class="min-w-full text-left text-gray-300 border-collapse">
        <thead>
          <tr>
            <th class="border-b py-2 pr-4 font-semibold">目的</th>
            <th class="border-b py-2 pr-4 font-semibold">收集的個人資料</th>
            <th class="border-b py-2 font-semibold">法律依據</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              評估求職申請
            </td>
            <td class="border-b py-2 pr-4 align-top">
              電子郵件、姓名、年齡、性別、履歷（CV）
            </td>
            <td class="border-b py-2 align-top">
              履行契約或於訂立契約前應您的要求採取措施所必要
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              註冊並驗證帳號
            </td>
            <td class="border-b py-2 pr-4 align-top">
              電子郵件、姓名、年齡、性別、外部帳號資訊、使用者名稱、密碼
            </td>
            <td class="border-b py-2 align-top">
              您的事前、明確、自由且具體知情的同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              提供個人化的遊戲體驗
            </td>
            <td class="border-b py-2 pr-4 align-top">
              使用者名稱、裝置/連線資訊、所選興趣、遊戲行為、回饋
            </td>
            <td class="border-b py-2 align-top">
              您的事前、明確、自由且具體知情的同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              回應詢問或投訴
            </td>
            <td class="border-b py-2 pr-4 align-top">
              姓名、電子郵件，以及您主動提供的其他資訊
            </td>
            <td class="border-b py-2 align-top">
              為改善平台品質而有的正當利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              通知平台新功能
            </td>
            <td class="border-b py-2 pr-4 align-top">
              使用者名稱、電子郵件地址
            </td>
            <td class="border-b py-2 align-top">
              為向您傳達平台相關資訊而有的正當利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              分析使用統計以優化平台
            </td>
            <td class="border-b py-2 pr-4 align-top">
              使用者行為資料（使用與裝置資訊）、遊戲內統計
            </td>
            <td class="border-b py-2 align-top">
              為理解平台表現與使用者體驗而有的正當利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              符合法律義務
            </td>
            <td class="border-b py-2 pr-4 align-top">
              依適用法律規定所需之資料
            </td>
            <td class="border-b py-2 align-top">
              符合法定義務之必要
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              預防、偵測並打擊詐騙或未經授權行為
            </td>
            <td class="border-b py-2 pr-4 align-top">
              為偵測詐騙或違法活動所需之資料
            </td>
            <td class="border-b py-2 align-top">
              為避免詐騙及違法行為的正當利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              行銷通訊
            </td>
            <td class="border-b py-2 pr-4 align-top">
              使用者名稱、電子郵件地址
            </td>
            <td class="border-b py-2 align-top">
              您的事前、明確、自由且具體知情的同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              在平台上投放廣告
            </td>
            <td class="border-b py-2 pr-4 align-top">
              透過 Cookie 或類似技術取得之資料（IP 位址、使用者 ID、瀏覽器類型等）
            </td>
            <td class="border-b py-2 align-top">
              您於接受本隱私權及 Cookie 政策並確認廣告偏好設定時所提供之明確同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              履行與遊戲開發者之合約
            </td>
            <td class="border-b py-2 pr-4 align-top">
              電子郵件、稅號、銀行帳戶資訊、付款相關資訊
            </td>
            <td class="border-b py-2 align-top">
              契約履行所必要
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              處理遊戲內購買
            </td>
            <td class="border-b py-2 pr-4 align-top">
              與購買相關資料（由第三方支付服務執行）
            </td>
            <td class="border-b py-2 align-top">
              契約履行所必要
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>帳號註冊：</strong> 當您註冊帳號時，即表示您同意向我們提供密碼、電子郵件、user agent、IP 位址等資訊。我們可能支援使用 Facebook、Google 等第三方服務登入。若您選擇此方式，表示您允許該服務分享您的姓名、電子郵件地址、出生日期等資訊給我們。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>廣告：</strong> 我們可能在平台上顯示來自不同廣告商的廣告，可能包含個人化或非個人化廣告。個人化廣告需要您事先同意，因此可能會將某些資料（如 IP、廣告識別碼）分享給第三方廣告網路。您可透過我們的 Cookie 管理工具或瀏覽器設定來調整您的廣告偏好。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>自動化分析（Profiling）：</strong> 我們可能分析您的遊戲數據（如遊戲內統計）以便向您推薦適合的遊戲，但這不構成對您產生重大法律或類似影響的自動化決策。如果您位於歐洲經濟區或英國等地區，您可能有權隨時拒絕我們對您的個人資料進行直接行銷或相關的自動化分析。
    </p>
  </section>

  <!-- 5. 我們會與他人共享您的個人資料嗎 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">我們會與他人共享您的個人資料嗎</h2>
    <p class="text-gray-300 leading-relaxed">
      我們可能在下列情況與他人共享您的個人資料：
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li>
        <strong>服務供應商：</strong> 例如協助我們進行 IT 服務、支付處理或數據分析的第三方公司
      </li>
      <li>
        <strong>其他使用者：</strong> 如果您選擇公開或部分公開個人檔案（例如使用者名稱、遊戲紀錄），則其他使用者可能看得到。您可在帳號設定中調整。
      </li>
      <li>
        <strong>廣告：</strong> 我們可能會將某些匿名或雜湊處理後的資訊（例如雜湊後的電子郵件、IP）提供給廣告業者，用於個人化廣告，但必須事先取得您的同意。
      </li>
      <li>
        <strong>遊戲開發者：</strong> 有些遊戲是外部開發者製作。我們可能與其共享匿名化的使用統計數據，或與遊戲內購買有關的必要資訊。
      </li>
      <li>
        <strong>支付服務商：</strong> 如果您在遊戲內進行購買，該交易由第三方支付服務商處理。雖然我們會將您的購買記錄與您的帳號連結，但不直接收集完整的支付資訊。
      </li>
      <li>
        <strong>跨國資料傳輸：</strong> 您的資料可能被傳輸至您所在地以外的區域，我們會採取適當的保護措施（例如簽署標準合約條款）以確保您的資料受到保護。
      </li>
    </ul>
  </section>

  <!-- 6. 我們會保存您的個人資料多久 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">我們會保存您的個人資料多久</h2>
    <p class="text-gray-300 leading-relaxed">
      我們僅在達成本政策所述目的所需的期間內保存您的個人資料。如果您擁有帳號，除非您請求刪除或基於法律及商業需求，我們通常會保留相關資料。請注意，若您刪除帳號，此動作無法復原，也將無法再存取與該帳號相關的紀錄。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      在某些情況下，若有法律規定、爭議解決需求或防範詐騙之必要，我們可能在更長期間內保存您的資料。
    </p>
  </section>

  <!-- 7. OXO Play 會安全保護您的資料嗎 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">OXO Play 會安全保護您的資料嗎</h2>
    <p class="text-gray-300 leading-relaxed">
      我們採用合理且適當的技術與組織安全措施（例如加密、防火牆、存取控制等）來保護您的個人資料免於遺失、竊取或未經授權存取。我們也會限制僅有必須接觸個人資料的員工、合作夥伴及代理人才能存取資料。如與第三方廠商合作處理資料，我們同樣要求其遵守嚴格的保護標準。
    </p>
  </section>

  <!-- 8. 您對自己的個人資料擁有掌控權 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">您對自己的個人資料擁有掌控權</h2>
    <p class="text-gray-300 leading-relaxed">
      根據您所屬地區的法律規範，您可能享有下列權利：
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li><strong>查詢與副本：</strong> 請求取得我們所保有您的個人資料副本</li>
      <li><strong>更正：</strong> 如發現個人資料不正確或已變更，要求更新或更正</li>
      <li><strong>刪除（被遺忘權）：</strong> 在沒有正當理由繼續保存的情況下，要求刪除個人資料</li>
      <li><strong>限制處理：</strong> 在特定情況下，要求暫停對個人資料的處理</li>
      <li><strong>撤回同意：</strong> 隨時撤回先前向我們所提供的同意</li>
      <li><strong>拒絕行銷/自動化分析：</strong> 拒絕接收直接行銷或基於個人資料的自動化分析</li>
      <li><strong>資料可攜權：</strong> 要求以結構化、常用且機器可判讀的格式取得您的個人資料</li>
      <li><strong>不受歧視：</strong> 因行使上述權利而不會受到歧視</li>
    </ul>
    <p class="text-gray-300 leading-relaxed mt-4">
      如果您想行使上述權利，請透過網站提供的管道（例如聯絡表單或電子郵件）與我們聯繫。我們會在合理時間內（並遵守適用法律）回應您的請求，可能需要您提供身分驗證。
    </p>
  </section>

  <!-- 9. 管理您的廣告偏好 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">管理您的廣告偏好</h2>
    <p class="text-gray-300 leading-relaxed">
      當您首次造訪我們的網站時，您可透過我們的同意管理平台（Consent Management Platform, CMP）選擇接受或拒絕某些 Cookie。您可以隨時於帳號設定或「Preferences」連結中更改這些偏好。您也可以在瀏覽器層級設定以阻擋 Cookie，但可能因此影響部分平台功能使用。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      若想瞭解更多關於行為定向廣告或您的選擇權，請參考相關廣告組織或協會所提供的資訊。
    </p>
  </section>

  <!-- 10. 兒童隱私 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">兒童隱私</h2>
    <p class="text-gray-300 leading-relaxed">
      本平台僅提供給年滿 13 歲（或當地最低年齡）以上的使用者使用。我們不會刻意向 13 歲以下的兒童收集個人資料。若您發現我們意外收集到該年齡以下兒童的個人資料，請儘速與我們聯繫，我們會在確認後立即刪除相關資料。
    </p>
  </section>

  <!-- 11. 其他網站的連結 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">其他網站的連結</h2>
    <p class="text-gray-300 leading-relaxed">
      我們的平台或部分遊戲可能包含通往第三方網站的連結，這些網站並非由我們運營。我們不對任何第三方網站或服務的隱私實務負責，建議您在使用該等網站時先行閱讀其隱私政策。
    </p>
  </section>

  <!-- 12. 外部託管的遊戲 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">外部託管的遊戲</h2>
    <p class="text-gray-300 leading-relaxed">
      本政策不適用於 OXO Play 以外的資料控管者或遊戲開發者所營運的遊戲。我們會要求這些開發者遵守適用的資料保護法律，但您仍應在開始遊玩前閱讀該開發者的隱私政策。
    </p>
  </section>

  <!-- 13. 美國隱私權 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">美國隱私權</h2>
    <p class="text-gray-300 leading-relaxed">
      部分美國州法律賦予使用者對個人資料的特定權利，例如存取、刪除或拒絕「出售」或「分享」個人資訊的權利。我們將遵守相關法律，並協助符合條件的使用者行使這些權利。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      我們不會因應使用者行使上述權利而對其進行差別待遇。
    </p>
  </section>

  <!-- 14. 本隱私權政策的變更 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">本隱私權政策的變更</h2>
    <p class="text-gray-300 leading-relaxed">
      我們可能會不時更新本政策，並在文件頂端標示「最後更新」日期。若有重大變更，我們也可能透過平台公告或電子郵件等方式通知您。若您在政策更新後持續使用平台，即表示您同意並接受更新後的內容。
    </p>
  </section>

  <!-- 15. 關於您的資料有更多問題嗎 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">關於您的資料有更多問題嗎</h2>
    <p class="text-gray-300 leading-relaxed">
      若您對本隱私權政策或我們如何處理您的個人資料有任何疑問，請透過
      <a href="/contact" class="underline hover:no-underline">Contact Us</a>
      頁面或提供之電子郵件與我們聯繫。如果您認為我們未能妥善處理您的疑慮，也有權向當地的資料保護主管機關提出申訴。
    </p>
  </section>
</div>
`; 